{
  "id": "apollo",
  "pantheon": "greeks",
  "name": {
    "pt-BR": "Apolo",
    "en": "Apollo"
  },
  "icon": "gods/apollo",
  "portrait": "gods/apollo-portrait",
  "age": "heroic",
  "freeUnitsOnAgeUp": {
    "manticore": 1
  },
  "unlocks": ["manticore", "anastrophe", "oracle", "temple-of-healing", "sun-ray"],
  "powers": ["underworld-passage"],
  "meta": {
    "source": "Game files 19.17020 (techtree.xml)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "HeroicAgeApollo: CreateUnit Manticore at a Temple (one free myth unit), god power UnderworldPassage (cooldown 180 s); enables the listed unit and techs."
  }
}
